export default {
    driver_performance_case_overview_caseID: "ID de Caso",
    driver_performance_case_overview_driver: "Conductor",
    driver_performance_case_overview_created: "Creado",
    driver_performance_case_overview_status: "Estado",
    driver_performance_case_overview_coach: "Supervisor",
    driver_performance_case_overview_completed: "Completado",
    driver_performance_case_overview_nextStep: "Siguiente Paso",
    driver_performance_case_overview_tags: "Etiquetas",
    driver_performance_case_overview_overview: "Descripción General",
    driver_performance_case_overview_risk: "Riesgo",
    driver_performance_case_overview_improvementPlan: "Plan de Mejora",
    driver_performance_case_overview_cases: "Casos",
    driver_performance_case_overview_updateCoach: "Reasignar Supervisor",
    driver_performance_case_overview_finish: "Finalizar",
    driver_performance_case_overview_escalate: "Escalar",
    driver_performance_case_overview_hideDescription: "Ocultar Descripción",
    driver_performance_case_overview_showDescription: "Mostrar Descripción",
}